import { setCookie, getCookie } from 'tiny-cookie';
import { getQueryStringParams } from 'lib/utils';
import { getStartMessage } from './startMessage';
import axios from 'axios';
import "clientjs";
const BrowserFingerprint = require("browser_fingerprint");

const params = getQueryStringParams();

export function generateId() {
  return Math.random().toString();
}

export async function sendMessage(message) {
  message = message.toLowerCase();

  console.log({
    ...getQueryStringParams(),
    messages: [
      {
        type: 'simpleMessage',
        text: message
      }
    ]
  }
  );

  const res = {
    meta: {
      ...getQueryStringParams()
    },
    data: {
      messages: []
    }
  };

  if (message === 'start') {
    res.data.messages = getStartMessage();
  }
  else {
    let fingerprint = getCookie('__chatbot');
    if (!fingerprint) {
      fingerprint = new ClientJS().getFingerprint();
      const date = new Date;
      date.setDate(date.getDate() + 21);
      setCookie('__chatbot', fingerprint.toString(), { expires: date });
    }
    const endpointUrl = params['serviceUrl'] || window.location.origin + "/dialogflowWebhook";
    const payload = {
      message: message,
      userId: params['session'] ? params['session'] : fingerprint.toString(),
      plataform: 'webfront',
      pageOrigin: params['page'],
      shoppingId: params['shoppingSlug'] ? params['shoppingSlug'] : 'ssu',
      isDevelopment: params['isDevelopment'] ? params['isDevelopment'] : false,
    };

    const response = await axios.post(endpointUrl, payload);
    let cleanResponse = response.data;
    if (response.data.length > 0) {
      cleanResponse = response.data.slice(0, response.data.length - 1);
    }
    if (params['debug']) {
      const lastMessage = response.data.slice(response.data.length - 1, response.data.length);
      console.log(`MDATA: ${JSON.stringify(payload)}`);
      console.log(`Fingerprint: ${fingerprint}`);
      console.log(lastMessage.map(x => x.text.split('<br>').join('\n')).join(' \n '));
    }

    res.data.messages = cleanResponse;
  }
  return res;
}
